import http from '../../utils/http'

// Endpoints
const resetPasswordEndpoint = '/users/reset_password'
const recoverPasswordEndpoint = '/users/recover_password'
const changeTemporaryPassword = '/users/change_temporary_password'

export const recoverPassword = recoverData => http
  .post(recoverPasswordEndpoint, {
    login: recoverData.login,
    locale: recoverData.locale
  })
  .then(res => res.data)

export const resetPassword = async (resetData) => {
  const resetType = resetData.token ? {
    token: resetData.token,
    password: resetData.password,
    locale: resetData.locale
  } : {
    fractal_id: resetData.fractal_id,
    secret_answer: resetData.secret_answer,
    password: resetData.password,
    locale: resetData.locale
  }

  const response = await http.post(resetPasswordEndpoint, resetType)
  return response
}

export const changeTemporaryPasswordService = async (data) => {
  const body = {
    email: data.email,
    password: data.password
  }
  const response = await http.put(changeTemporaryPassword, body, {
    headers: {
      'X-Token': data.token
    }
  })
  return response
}
